// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import type {
  BootstrapTenantRequestDto,
  BootstrapTenantResponseDto,
  InvitationRequestDto,
  InvitationResponseDto,
  JoinTenantRequestDto,
  JoinTenantResponseDto,
  OnboardingSessionDto,
} from "../dto/onboardingDtos";
import type {
  BootstrapTenantInputModel,
  BootstrapTenantModel,
  InvitationInputModel,
  InvitationModel,
  JoinTenantInputModel,
  JoinTenantModel,
  OnboardingSessionModel,
} from "../models/onboardingModels";

export function mapOnboardingSessionDtoToModel(
  dto: OnboardingSessionDto,
): OnboardingSessionModel {
  return { ...dto };
}

export function mapBootstrapTenantResponseDtoToModel(
  dto: BootstrapTenantResponseDto,
): BootstrapTenantModel {
  return { ...dto };
}

export function mapInvitationResponseDtoToModel(
  dto: InvitationResponseDto,
): InvitationModel {
  return { ...dto };
}

export function mapJoinTenantResponseDtoToModel(
  dto: JoinTenantResponseDto,
): JoinTenantModel {
  return { ...dto };
}

export function toBootstrapTenantRequestDto(
  input: BootstrapTenantInputModel,
): BootstrapTenantRequestDto {
  return {
    ...input,
    purpose: "bootstrap-tenant",
  };
}

export function toInvitationRequestDto(
  input: InvitationInputModel,
): InvitationRequestDto {
  return { ...input };
}

export function toJoinTenantRequestDto(
  input: JoinTenantInputModel,
): JoinTenantRequestDto {
  return {
    ...input,
    purpose: "join-tenant",
  };
}
